<nav
  class="flex items-center h-full w-full min-w-0"
  role="navigation"
  aria-label="Selector de vehículo y tienda"
>
  @if(showVehicle) {
  <ng-container [ngTemplateOutlet]="vehicleSelector"></ng-container>
  } @if(showSeparator) {
  <ng-container [ngTemplateOutlet]="separator"></ng-container>
  } @if(showStore) {
  <ng-container [ngTemplateOutlet]="storeSelector"></ng-container>
  }
</nav>

<!-- Templates -->
<ng-template #vehicleSelector>
  <section
    class="flex justify-center min-w-0"
    [ngClass]="{
      'w-1/2': whichShow === 'both',
      'w-full': whichShow === 'vehicle'
    }"
    aria-label="Selector de vehículo"
  >
    <button
      type="button"
      class="flex gap-1.5 items-center justify-center p-0 md:p-2 md:px-3 text-gray-700 hover:text-allasRed transition-colors w-full min-w-0 fs-condensed"
      (click)="goToGarage()"
      aria-label="Seleccionar vehículo"
    >
      <img
        src="/allas-icons/vehicle-new.svg"
        alt="Icono de vehículo"
        class="xl:w-auto h-3 xl:h-4 flex-shrink-0"
        width="16"
        height="16"
        loading="lazy"
      />
      <div class="flex flex-col items-start">
        <span
          class="font-medium text-xs xl:text-sm min-w-0 whitespace-nowrap overflow-hidden text-ellipsis w-full text-left"
          [title]="getVehicleDisplayText()"
        >
          {{ getVehicleDisplayText() }}
        </span>
      </div>
      <lucide-icon
        [name]="chevronRightIcon"
        class="w-auto h-4 flex-shrink-0"
        aria-hidden="true"
      ></lucide-icon>
    </button>
  </section>
</ng-template>

<ng-template #separator>
  <div
    class="w-px h-6 bg-gray-300 mx-1 lg:mx-2 flex-shrink-0"
    role="separator"
    aria-hidden="true"
  ></div>
</ng-template>

<ng-template #storeSelector>
  <section
    class="flex justify-center min-w-max"
    [ngClass]="{
      'w-1/2': whichShow === 'both',
      'w-full': whichShow === 'store'
    }"
    aria-label="Selector de tienda"
  >
    <allas-my-store-selector (onStoreSelect)="handleStoreSelect($event)">
      <button
        type="button"
        class="flex gap-1.5 items-center justify-center p-0 md:p-2 md:px-3 text-gray-700 hover:text-allasRed transition-colors w-full min-w-0 fs-condensed"
        aria-label="Seleccionar tienda"
      >
        <ng-container [ngTemplateOutlet]="storeIcon"></ng-container>
        <div class="flex flex-col items-start min-w-0 flex-1">
          <span
            class="font-medium text-xs xl:text-sm min-w-0 whitespace-nowrap overflow-hidden text-ellipsis w-full text-left"
            [title]="storeData().storeName"
          >
            {{ storeData().storeName }}
          </span>
          @if(storeData().statusText) {
          <span
            class="text-xs xl:text-sm font-light fs-condensed text-gray-500 min-w-0 whitespace-nowrap overflow-hidden text-ellipsis w-full text-left"
            [title]="storeData().statusText"
          >
            {{ storeData().statusText }}
          </span>
          }
        </div>
        <lucide-icon
          [name]="chevronRightIcon"
          class="w-auto h-4 flex-shrink-0"
          aria-hidden="true"
        ></lucide-icon>
      </button>
    </allas-my-store-selector>
  </section>
</ng-template>

<ng-template #storeIcon>
  @if (thereIsStoreSelected()) {
  <img
    src="/allas-icons/icon-store-selected-m.svg"
    alt="Tienda seleccionada"
    class="h-4 xl:h-5 flex-shrink-0"
    width="24"
    height="24"
    loading="lazy"
  />
  } @else {
  <img
    src="/allas-icons/store-new.svg"
    alt="Seleccionar tienda"
    class="h-4 xl:h-5 flex-shrink-0"
    width="24"
    height="24"
    loading="lazy"
  />
  }
</ng-template>
